import { useCallback, useEffect, useState } from 'react';
import { RoomEvent, ScreenSharePresets, Track } from 'livekit-client';
import { toast } from 'react-toastify';
export function useScreenShare(room) {
    const [isScreenSharing, setIsScreenSharing] = useState(false);
    useEffect(() => {
        if (!room)
            return;
        const handleTrackUnpublished = (publication, participant) => {
            if (participant.isLocal && publication.source === Track.Source.ScreenShare) {
                setIsScreenSharing(false);
            }
        };
        room.on(RoomEvent.TrackUnpublished, handleTrackUnpublished);
        return () => {
            room.off(RoomEvent.TrackUnpublished, handleTrackUnpublished);
        };
    }, [room]);
    // Отслеживаем остановку screen share через браузер
    useEffect(() => {
        if (!room || !isScreenSharing)
            return;
        const screenShareTrack = room.localParticipant.getTrackPublication(Track.Source.ScreenShare)?.track;
        if (!screenShareTrack?.mediaStreamTrack)
            return;
        const handleTrackEnded = () => {
            console.log('Screen share track ended by browser');
            setIsScreenSharing(false);
            toast.info('Трансляция экрана остановлена');
        };
        screenShareTrack.mediaStreamTrack.addEventListener('ended', handleTrackEnded);
        return () => {
            screenShareTrack.mediaStreamTrack?.removeEventListener('ended', handleTrackEnded);
        };
    }, [room, isScreenSharing]);
    const startScreenShare = useCallback(async () => {
        if (!room)
            return;
        try {
            const publication = await room.localParticipant.setScreenShareEnabled(true, {
                resolution: ScreenSharePresets.h720fps15.resolution,
                contentHint: 'detail',
            });
            const settings = publication?.track?.mediaStreamTrack?.getSettings();
            console.debug('Screen share capture settings', {
                width: settings?.width,
                height: settings?.height,
                frameRate: settings?.frameRate,
            });
            setIsScreenSharing(true);
            toast.success('Трансляция экрана начата');
        }
        catch (error) {
            console.error('Failed to start screen share:', error);
            if (error.name === 'NotAllowedError' || error.name === 'AbortError') {
                toast.info('Трансляция экрана отменена');
            }
            else {
                toast.error('Не удалось начать трансляцию экрана');
            }
        }
    }, [room]);
    const stopScreenShare = useCallback(async () => {
        if (!room)
            return;
        try {
            await room.localParticipant.setScreenShareEnabled(false);
            setIsScreenSharing(false);
            toast.success('Трансляция экрана остановлена');
        }
        catch (error) {
            console.error('Failed to stop screen share:', error);
            toast.error('Ошибка при остановке трансляции экрана');
        }
    }, [room]);
    const cleanup = useCallback(async () => {
        if (isScreenSharing && room) {
            try {
                await room.localParticipant.setScreenShareEnabled(false);
                setIsScreenSharing(false);
            }
            catch (error) {
                console.error('Failed to stop screen share on cleanup:', error);
            }
        }
    }, [isScreenSharing, room]);
    return {
        isScreenSharing,
        startScreenShare,
        stopScreenShare,
        cleanup,
    };
}
